var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpain = function SvgSpain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Spain_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Spain_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v24h36V0H0Z",
    fill: "#FFB400"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Spain_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v24h36V0H0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Spain_svg__b)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v6h36V0H0ZM0 18v6h36v-6H0Z",
    fill: "#C51918"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FF",
    d: "M5.634 10.272h1.26v5.824h-1.26z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.398 9.264H5.13v.56h.378v.448H7.02v-.448h.378v-.56ZM7.02 16.432h.378v.56H5.13v-.56h.378v-.448H7.02v.448Z",
    fill: "#C88A02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.264 9.376c.274 0 .302-.092.464-.229.126-.106.418-.238.418-.387 0-.34-.395-.616-.882-.616s-.882.276-.882.616c0 .166.202.276.354.387.16.117.278.229.528.229Z",
    fill: "#AD1619"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13 16.992h2.268v.896s-.283-.112-.567-.112c-.283 0-.567.112-.567.112s-.283-.112-.567-.112c-.283 0-.567.112-.567.112v-.896Z",
    fill: "#005BBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Spain_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 16,
    width: 3,
    height: 2
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13 16.992h2.268v.896s-.283-.112-.567-.112c-.283 0-.567.112-.567.112s-.283-.112-.567-.112c-.283 0-.567.112-.567.112v-.896Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Spain_svg__c)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.11 17.712-.05-.107c.204-.081.41-.122.615-.122.132 0 .202.017.32.063a.61.61 0 0 0 .27.054.61.61 0 0 0 .27-.054.737.737 0 0 1 .32-.063c.205 0 .41.04.614.122l-.05.107a1.527 1.527 0 0 0-.565-.112.61.61 0 0 0-.27.054.737.737 0 0 1-.32.063.737.737 0 0 1-.32-.063.61.61 0 0 0-.27-.054c-.187 0-.375.037-.564.112ZM5.11 17.376l-.05-.107c.204-.081.41-.121.615-.121.132 0 .202.016.32.063a.61.61 0 0 0 .27.053.61.61 0 0 0 .27-.053.737.737 0 0 1 .32-.063c.205 0 .41.04.614.12l-.05.108a1.527 1.527 0 0 0-.565-.112.61.61 0 0 0-.27.054.737.737 0 0 1-.32.063.737.737 0 0 1-.32-.063.61.61 0 0 0-.27-.054c-.187 0-.375.037-.564.112Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FF",
    d: "M17.982 10.272h1.26v5.824h-1.26z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.746 9.264h-2.268v.56h.378v.448h1.512v-.448h.378v-.56ZM19.368 16.432h.378v.56h-2.268v-.56h.378v-.448h1.512v.448Z",
    fill: "#C88A02"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.612 9.376c.274 0 .302-.092.464-.229.126-.106.418-.238.418-.387 0-.34-.395-.616-.882-.616s-.882.276-.882.616c0 .166.202.276.354.387.16.117.278.229.528.229Z",
    fill: "#AD1619"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.478 16.992h2.268v.896s-.284-.112-.567-.112c-.284 0-.567.112-.567.112s-.284-.112-.567-.112c-.284 0-.567.112-.567.112v-.896Z",
    fill: "#005BBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Spain_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 16,
    width: 3,
    height: 2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.478 16.992h2.268v.896s-.284-.112-.567-.112c-.284 0-.567.112-.567.112s-.284-.112-.567-.112c-.284 0-.567.112-.567.112v-.896Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Spain_svg__d)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.457 17.712-.049-.107c.204-.081.41-.122.615-.122.132 0 .201.017.32.063a.61.61 0 0 0 .27.054.61.61 0 0 0 .27-.054.737.737 0 0 1 .32-.063c.204 0 .41.04.614.122l-.05.107a1.527 1.527 0 0 0-.565-.112.61.61 0 0 0-.27.054.737.737 0 0 1-.32.063.737.737 0 0 1-.32-.063.61.61 0 0 0-.27-.054c-.187 0-.376.037-.564.112ZM17.457 17.376l-.049-.107c.204-.081.41-.121.615-.121.132 0 .201.016.32.063a.61.61 0 0 0 .27.053.61.61 0 0 0 .27-.053.737.737 0 0 1 .32-.063c.204 0 .41.04.614.12l-.05.108a1.527 1.527 0 0 0-.565-.112.61.61 0 0 0-.27.054.737.737 0 0 1-.32.063.737.737 0 0 1-.32-.063.61.61 0 0 0-.27-.054c-.187 0-.376.037-.564.112Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.612 15.68c.227-.245.354-.468.354-.704 0-.15-.05-.278-.138-.383l.015-.006c-.001 0 .25-.097.337-.134.162-.07.305-.142.444-.232a3.58 3.58 0 0 1 .39-.207l.17-.08.046-.023c.089-.041.154-.074.216-.105.19-.098.316-.18.412-.288.228-.257.18-.605-.139-.798-.156-.095-.367-.149-.677-.192l-.064-.008-.378-.053c-.148-.02-.28-.04-.398-.058.774-.114 1.88-.072 2.367.151l.462-.796c-.991-.455-3.25-.409-4.094.108-.62.379-.536.951.108 1.198.27.103.62.172 1.27.264a3.298 3.298 0 0 0-.284.162 1.86 1.86 0 0 1-.287.15c-.053.022-.21.083-.282.11l-.036.015c-.525.212-.78.505-.703 1.035l.041.287.074.02.774.567Zm-.649-.74-.001.003v-.003h.001Zm13.831.036c0 .236.127.46.354.704l.774-.567.074-.02.041-.287c.076-.53-.178-.823-.703-1.035l-.036-.014-.282-.112a1.857 1.857 0 0 1-.287-.149 3.29 3.29 0 0 0-.283-.162c.65-.092 1-.16 1.27-.264.643-.247.726-.82.107-1.198-.844-.517-3.103-.563-4.094-.108l.462.796c.487-.223 1.593-.265 2.367-.15a26.656 26.656 0 0 1-.776.11l-.064.008c-.31.043-.52.097-.677.192-.32.193-.367.541-.139.798.096.109.222.19.412.288.062.031.127.064.216.105l.046.022.17.08c.182.088.301.15.39.208.14.09.282.163.445.232.087.037.337.134.336.134l.015.006a.587.587 0 0 0-.138.383Z",
    fill: "#AD1619"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m6.664 12.4.372.068v.493c-.396.281-1.402.755-1.402.755V12.4h1.03ZM18.354 12.4l-.372.068v.493c.396.281 1.402.755 1.402.755V12.4h-1.03Z",
    fill: "#F1F9FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.623 7.206v-.164c-.648-.414-1.327-.62-2.036-.62a4.517 4.517 0 0 0-2.065-.312v-.003c-1.047-.09-2.102.315-2.102.315-1.064 0-2.036.62-2.036.62v.164l1.27 1.134s.358 1.092 2.864.836v.002s1.658-.04 1.775-.074c.046-.014.094-.026.143-.04.325-.083.696-.18.916-.724l1.271-1.134ZM12.517 6.16c-.036.378-.242 2.655 0 3.008V6.16Z",
    fill: "#AD1619"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.353 8.15.001-.004-.894-.748.086-.081.84.702.02-.088c.138.026.238.036.297.03V7.81l.186.09c.091.044.222.056.395.03.127-.018.212-.149.24-.427l.056-.563.19.54c.085.243.216.351.402.351.182 0 .255-.06.263-.209l.023-.423.215.378a.357.357 0 0 0 .337.198c.218 0 .363-.161.363-.414h.256c0 .253.146.414.363.414.152 0 .26-.062.337-.198l.215-.378.023.423c.008.15.081.209.263.209.186 0 .317-.108.402-.352l.19-.539.056.563c.028.278.114.41.24.428.173.025.304.013.396-.031l.185-.09v.152c.059.006.16-.004.296-.03l.04.163.93-.777.085.082-1.155.966c-.169.276-.254.458-.254.534 0 .115-.338.184-.997.254-.517.055-1.127.092-1.626.098h-.126a18.245 18.245 0 0 1-1.625-.098c-.66-.07-.998-.139-.998-.254a.211.211 0 0 0-.009-.054.831.831 0 0 1-.144-.31 5.488 5.488 0 0 0-.1-.17l-.256-.214-.007-.001Zm6.194.018c-.207.032-.356.029-.435-.028a1.11 1.11 0 0 1-.434.01c-.177-.025-.3-.13-.374-.303a.592.592 0 0 1-.366.2c.806.1 1.371.244 1.371.244s-.014.106-.047.23c.035-.065.078-.137.127-.217l.012-.014.146-.122Zm-1.99-.164a.392.392 0 0 1-.166-.134.583.583 0 0 1-.204.103c.126.008.25.019.37.03Zm-.815-.053a.562.562 0 0 1-.24-.188.562.562 0 0 1-.24.187l.174-.003h.101c.069 0 .137.002.205.004Zm-3.042.33-.117-.097c.14.012.245 0 .307-.044.123.032.269.035.434.01.177-.025.3-.13.374-.303a.591.591 0 0 0 .353.197c-.695.087-1.213.205-1.35.238Zm2.11-.31c-.122.008-.242.018-.358.03a.39.39 0 0 0 .16-.131c.058.046.124.08.198.101Zm3.1.93c.088.037.159 0 .215-.07a.326.326 0 0 0-.01.053.231.231 0 0 1-.033.015 1.337 1.337 0 0 1-.187.048 7.7 7.7 0 0 1-.666.095c-.534.057-1.169.095-1.673.098a17.93 17.93 0 0 1-1.674-.098 7.7 7.7 0 0 1-.666-.095 1.563 1.563 0 0 1-.166-.04.213.213 0 0 0 .014-.006c.275-.114 2.095-.222 2.423-.24.328.018 2.148.126 2.423.24Zm.347-.02-.002.001h.001Zm0 0Z",
    fill: "#C88A02"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.502 5.347c.208 0 .377-.15.377-.336 0-.185-.169-.336-.377-.336-.21 0-.379.15-.379.336 0 .186.17.336.379.336Z",
    fill: "#005BBF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.256 6.997c.008.037.02.071.036.102a.531.531 0 0 0-.169-.027c-.174 0-.315.076-.315.168 0 .093.141.168.315.168.174 0 .315-.075.315-.168v-.005.005c0 .093.141.168.316.168.173 0 .315-.075.315-.168 0-.092-.142-.168-.316-.168a.559.559 0 0 0-.123.014.375.375 0 0 0-.003-.153c-.033-.152-.143-.26-.246-.243-.102.018-.158.155-.125.307Zm-1.854.214a.414.414 0 0 1-.036-.102c-.034-.152.023-.29.125-.307.103-.018.213.09.246.243a.379.379 0 0 1 .003.153.56.56 0 0 1 .123-.014c.174 0 .315.076.315.168 0 .093-.14.168-.315.168-.174 0-.315-.075-.315-.168v-.005.005c0 .093-.14.168-.315.168-.174 0-.315-.075-.315-.168 0-.092.141-.168.315-.168.063 0 .12.01.17.027Zm3.947.102c-.015.092-.166.149-.339.127-.172-.021-.3-.113-.285-.205.014-.092.166-.149.338-.127a.521.521 0 0 1 .163.046.4.4 0 0 1-.02-.105c-.01-.154.068-.283.172-.288.104-.005.196.116.205.27a.382.382 0 0 1-.02.153.562.562 0 0 1 .124.002c.172.021.3.113.286.205-.015.092-.167.149-.339.127-.172-.021-.3-.113-.285-.205v-.005.005Zm1.2.444c.153.073.317.065.366-.017l.003-.004a.126.126 0 0 0 .053.03c.1.027.222-.07.273-.219.05-.148.011-.29-.089-.317-.1-.027-.222.071-.272.219a.4.4 0 0 0-.022.105.475.475 0 0 0-.135-.093c-.154-.073-.318-.065-.367.016-.05.082.036.208.19.28Zm-6.183.035c-.154.072-.318.065-.367-.017a.104.104 0 0 1-.003-.005.126.126 0 0 1-.053.03c-.1.027-.222-.07-.273-.218-.05-.148-.011-.29.089-.317.1-.027.222.07.273.218.012.036.019.072.021.105a.474.474 0 0 1 .135-.093c.154-.073.318-.065.367.017.05.082-.036.207-.19.28ZM12.36 4.077h.263v.147h.171v.233h-.171v.467h.171v.233h-.608v-.233h.174v-.467h-.174v-.233h.174v-.147Z",
    fill: "#C88A02"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#C88A02",
    d: "M12.312 5.344h.504V6.8h-.504z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m10.283 5.588-.002.112c-1.117-.018-1.758.127-1.92.416-.169.299-.137.662.098 1.093l-.113.05c-.252-.461-.286-.86-.098-1.193.193-.343.87-.496 2.035-.478Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m10.5 6.58-.065.097c-.243-.129-.365-.35-.365-.653 0-.437.253-.693.813-.868.357-.111.845-.066 1.464.134l-.043.105c-.595-.191-1.055-.235-1.38-.133-.513.16-.728.378-.728.762 0 .266.101.45.304.557Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m8.618 7.037-.238.075c-.246-.625-.176-1.049.246-1.232.371-.16.912-.226 1.626-.2l-.01.223c-.676-.024-1.179.037-1.506.179-.277.12-.328.425-.118.955Z",
    fill: "#C88A02"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.396 5.439c-.576 0-.813.125-.948.493-.086.235-.003.435.268.622l-.154.177c-.351-.242-.475-.539-.354-.869.172-.469.51-.647 1.188-.647.444 0 .79.104 1.03.314l.038.033v1.08h-.252v-.984c-.188-.145-.458-.22-.816-.22Z",
    fill: "#C88A02"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m14.68 5.7.003.112c1.117-.018 1.758.127 1.92.416.169.299.137.662-.098 1.093l.113.049c.251-.46.286-.859.098-1.192-.193-.343-.871-.496-2.036-.478Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m14.286 6.604.065.097c.243-.13.365-.35.365-.654 0-.436-.253-.692-.813-.867-.357-.112-.845-.066-1.465.134l.043.105c.595-.192 1.056-.235 1.38-.134.513.161.729.379.729.762 0 .267-.102.45-.304.557Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m16.424 7.15.238.073c.247-.624.177-1.048-.245-1.23-.372-.162-.913-.228-1.627-.202l.01.224c.676-.024 1.18.036 1.506.178.277.12.328.426.118.956Z",
    fill: "#C88A02"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.632 5.456c.577 0 .813.125.948.493.086.235.003.435-.268.622l.155.177c.35-.242.474-.539.353-.869-.172-.469-.51-.647-1.188-.647-.444 0-.79.104-1.03.315l-.038.032v1.08h.252v-.984c.188-.145.458-.22.816-.22Z",
    fill: "#C88A02"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.406 9.264h8.19v6.541S15.988 18 12.501 18c-3.486 0-4.095-2.253-4.095-2.253V9.264Z",
    fill: "#E1E5E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Spain_svg__e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 9,
    width: 9,
    height: 9
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.406 9.264h8.19v6.541S15.988 18 12.501 18c-3.486 0-4.095-2.253-4.095-2.253V9.264Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Spain_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC034",
    d: "M8.406 13.296h4.158v4.368H8.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1619",
    d: "M8.91 13.52h.504v4.144H8.91zM10.674 13.52h.504v4.144h-.504zM9.792 13.52h.504v4.144h-.504zM11.556 13.52h.504v4.144h-.504zM8.406 9.152h4.158v4.256H8.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1619",
    d: "M12.438 13.184h4.158v4.256h-4.158z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FF",
    d: "M12.438 9.264h4.41v4.144h-4.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.17 9.6h.378v.93h.252v-.465h.378v.464h.378v.581h-.378v1.045h.378v.581H9.288v-.58h.378V11.11h-.378v-.58h.252v-.465h.378v.464h.252V9.6Z",
    fill: "#C88A02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.602 9.795.258-.245.541.45-.258.245-.541-.45Z",
    fill: "#C88A02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.155 16.14v-2.452h-3.15v2.431l.005.02c.16.603.703.909 1.57.909.867 0 1.41-.298 1.57-.888l.005-.02Zm-1.575.572c-.696 0-1.076-.208-1.197-.632v-2.056h2.394v2.075c-.12.41-.5.613-1.197.613Z",
    fill: "#FFC034"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.71 13.893h-.262v1.112l-1.035-1-.186.15.936.906h-.848v.336h.869l-.957.924.186.152 1.035-1v1.299h.262v-1.183l.914.884.186-.152-.957-.924h1.068v-.336h-1.047l.936-.905-.186-.152-.914.884v-.995Z",
    fill: "#FFC034"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.168 17.443S12.5 17.63 12.5 16.1c0 0-.026 1.343-2.813 1.343v1.208h5.481v-1.208Z",
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.501 14.192c.522 0 .945-.4.945-.896 0-.494-.423-.896-.945-.896-.521 0-.945.402-.945.896 0 .495.424.896.945.896Z",
    fill: "#005BBF",
    stroke: "#AD1619",
    strokeWidth: 1.167
  }))))));
};
export default SvgSpain;